import { render } from "./products-with-filter.vue?vue&type=template&id=5332c556&ts=true"
import script from "./products-with-filter.vue?vue&type=script&lang=ts"
export * from "./products-with-filter.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__